import { apiFetch, apiJson } from './http';

export type AuthUser = Record<string, unknown> & {
  username?: string;
  name?: string;
  email?: string;
};

export type LoginResult =
  | { success: true; token: string; user: AuthUser }
  | { success: false; message?: string };

export async function loginRequest(username: string, password: string, remember = false): Promise<LoginResult> {
  const res = await apiFetch('/api/auth/login.php', {
    method: 'POST',
    body: JSON.stringify({ username, password, remember }),
  });
  return res.json() as Promise<LoginResult>;
}

export type RegisterResult =
  | { success: true; token: string; user: AuthUser }
  | { success: false; message?: string };

export async function registerRequest(payload: {
  username: string;
  email: string;
  password: string;
  confirmPassword: string;
}): Promise<RegisterResult> {
  const res = await apiFetch('/api/auth/register.php', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  return res.json() as Promise<RegisterResult>;
}

export type CheckResult = { authenticated: boolean; user?: AuthUser /** ... */ };

export async function checkSession(): Promise<CheckResult> {
  try {
    return await apiJson<CheckResult>('/api/auth/check.php');
  } catch {
    return { authenticated: false };
  }
}

export async function logoutRequest(): Promise<void> {
  try {
    await apiFetch('/api/auth/logout.php', { method: 'POST' });
  } catch {
    /* ignore */
  }
}

export type PasswordResetRequestResult = { success: boolean; message?: string };

export async function requestPasswordReset(email: string): Promise<PasswordResetRequestResult> {
  const res = await apiFetch('/api/auth/forgot-password.php', {
    method: 'POST',
    body: JSON.stringify({ email: email.trim() }),
  });
  return res.json() as Promise<PasswordResetRequestResult>;
}

export type ResetPasswordResult = { success: boolean; message?: string };

export async function resetPasswordWithToken(payload: {
  token: string;
  password: string;
  confirmPassword: string;
}): Promise<ResetPasswordResult> {
  const res = await apiFetch('/api/auth/reset-password.php', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  return res.json() as Promise<ResetPasswordResult>;
}
